import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const BuilderGuard = ({ children }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        const userData = localStorage.getItem("user");

        if (!token || !userData) {
            forceLogout();
            return;
        }

        try {
            const user = JSON.parse(userData);

            if (user.role !== "builder") {
                forceLogout();
            }
        } catch (err) {
            forceLogout();
        }
    }, []);

    const forceLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("authUser");
        navigate("/login", { replace: true });
    };

    return children;
};

export default BuilderGuard;
